import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { selectAddresses, toggleSelectShippingAddress, useDispatch, useSelector } from "@jti/store";
import { AddressInfoBlock, SelectItemDialog, useConfig, useTranslations } from "@jti/ui";
import styles from "./SelectShippingAddressDialog.module.scss";
export const SelectShippingAddressDialog = ({ defaultSelectedAddressId, onSelectAddress, onCreateAddress, }) => {
    const dispatch = useDispatch();
    const { __ } = useTranslations();
    const { COUNTRY_NAME } = useConfig();
    const addresses = useSelector(selectAddresses);
    const isSelectingAddress = useSelector((state) => state.checkout.isSelectShippingAddress);
    const shippingSelectedAddressId = useSelector((state) => state.checkout.shippingSelectedAddressId);
    const closeModal = useCallback(() => {
        dispatch(toggleSelectShippingAddress(false));
    }, [dispatch]);
    const onSave = useCallback((addressId) => {
        onSelectAddress(addressId);
        closeModal();
    }, [dispatch, onSelectAddress]);
    const onCreateNew = useCallback(() => {
        onCreateAddress();
        closeModal();
    }, []);
    return (_jsx(SelectItemDialog, { className: styles.addressDialog, isOpened: isSelectingAddress, title: __("cart.checkout.shipping_address.edit_dialog.title"), subTitle: __("cart.checkout.shipping_address.edit_dialog.subTitle"), createNew: {
            label: __("cart.checkout.shipping_address.edit_dialog.create_new"),
            onClick: onCreateNew,
        }, items: addresses, defaultSelectedId: defaultSelectedAddressId || shippingSelectedAddressId, onSave: onSave, onClose: closeModal, renderItem: (address) => (_jsx(AddressInfoBlock, { variant: "cart2", address: {
                ...address,
                countryName: COUNTRY_NAME,
            }, isEditable: true })) }));
};
//# sourceMappingURL=SelectShippingAddressDialog.js.map